﻿import { IRccapCenterResponseAdditionalQuestionAnswer } from './rccap-center-response-additional-question-answer';

export interface IRccapCenterResponseRequest {
    id: number;
    issueDescription: string;
    questions: IRccapCenterResponseAdditionalQuestionAnswer[];
    rootCausePrimary: number;
    rootCauseSecondary: number;
    correctiveAction: string;
    responseDate: string;
    responder: string;
}
